import {
    Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';

@Component
/**
 * ProductCard Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Products card  Add To Cart
     */
    @Prop({ default: false }) addToCart!: boolean;

    /**
     * Count of rate
     */
    @PropSync('rateCount', { type: [String, Number] }) rate_count!: number | string; // eslint-disable-line camelcase

    /**
     * Average of rate
     */
    @PropSync('rateAverage', { type: [String, Number] }) rate_average!: number | string; // eslint-disable-line camelcase

    /**
     * Base gutter for rate
     */
    @Prop({ default: 5 }) rateGutter!: number | string;
    
    /**
     * Version of the Image
     */
    @Prop({ type: String, default: 'medium' }) imageVersion!: string;
    
    /**
     * Color of component
     */
    @Prop({ type: String, default: 'primary' }) color!: string;
}
